import { Component, OnInit,Output,EventEmitter,Input } from '@angular/core';
import { Dep } from './../../comm/class/auth';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {

    constructor(private route:ActivatedRoute,private router:Router) { }
        @Output() change_status: EventEmitter<boolean> = new EventEmitter();
        @Input() user:  any;
        ngOnInit(): void {
    }

    logout(){

        localStorage.removeItem('usertoken_plus2'+Dep.user.id);

        const  identity = Dep.getData().partner;
        Dep.logout();
        if(identity==1){
            this.router.navigate(['/', 'login']);
        }else{
            this.router.navigate(['/', 'signin']);
        }
        this.change_status.emit(false);
    }

}
